import { ReportContext } from '@bm-js/atlas-analytics'
import { AreaChart, BarChart, DonutChart } from '@tremor/react'

export enum PeriodOption {
  LastWeek = 'lastWeek',
  Last2Weeks = 'last2Weeks',
  Last30Days = 'lastMonth',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const graphComponentMap: Record<ReportContext, any> = {
  [ReportContext.uniqueUsersOverTime]: AreaChart,
  [ReportContext.usersPerRoute]: BarChart,
  [ReportContext.usersPerReferer]: DonutChart,
  [ReportContext.usersPerDevice]: DonutChart,
  [ReportContext.usersPerPlatform]: DonutChart,
  [ReportContext.usersPerOS]: DonutChart,
  [ReportContext.usersPerVendor]: DonutChart,
  [ReportContext.usersPerCountry]: DonutChart,
  [ReportContext.avgEngagementTimeOverTime]: AreaChart,
  [ReportContext.avgEngagementTimePerRoute]: BarChart,
}

const getDateStringDaysBeforeToday = (days: number): string => {
  const today = new Date()
  const date = new Date(today)
  date.setDate(today.getDate() - days)
  return date.toISOString().split('T')[0]
}

export const getDateQuery = (period: PeriodOption): string => {
  const today = new Date().toISOString().split('T')[0]
  switch (period) {
    case PeriodOption.LastWeek:
      return `startDate=${getDateStringDaysBeforeToday(7)}&endDate=${today}`
    case PeriodOption.Last2Weeks:
      return `startDate=${getDateStringDaysBeforeToday(14)}&endDate=${today}`
    case PeriodOption.Last30Days:
      return `startDate=${getDateStringDaysBeforeToday(30)}&endDate=${today}`
  }
}
